import { Message } from '~/components/component-library'
import { getChain, SupportedChainId } from '~/constants/chains'
import { useInsufficientGasWarning } from '~/hooks/transactions/useInsufficientGasWarning'
import { useTransactionCost } from '~/hooks/transactions/useTransactionCost'
import { useRelayNetworkInfo } from '~/hooks/useRelayNetworks'
import { BasicTransactionType } from '~/types'

interface InsufficientGasWarningProps {
  smartAccountId: string
  chainId: SupportedChainId
  transactionTypes: BasicTransactionType[]
  transactionCost: ReturnType<typeof useTransactionCost>
  isSponsored: boolean
}

export const InsufficientGasWarning = (props: InsufficientGasWarningProps) => {
  const { showWarning: showInsufficientGasWarning } =
    useInsufficientGasWarning(props)

  const relayNetwork = useRelayNetworkInfo(props.chainId)

  const symbol =
    getChain(props.chainId)?.nativeCurrency.symbol ??
    relayNetwork?.currency.symbol ??
    'gas tokens'

  if (showInsufficientGasWarning) {
    return (
      <Message variant="warning">
        <>
          This transaction may not succeed, as you may not have enough {symbol}{' '}
          to cover the gas cost. To ensure the transaction succeeds, fund your
          account with more {symbol} or reduce the amount you are sending.
        </>
      </Message>
    )
  } else {
    return null
  }
}
